import axios from 'axios';

// Create a reusable axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://webchat.supportedbusiness.com/api',
  withCredentials: true, // Include credentials in CORS requests
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach JWT token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  
  if (token) {
    
    config.headers.Authorization = `Bearer ${token}`;
    console.log('DEBUG - Authorization header set with valid token');
  } else {
    console.log('DEBUG - No token in localStorage');
  }
  return config;
});

// Response interceptor - handle 401 Unauthorized (token expired)
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      console.log('🔒 Token expired or unauthorized - logging out');
      
      // Clear all auth data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('role');
      localStorage.removeItem('loginSession');
      localStorage.removeItem('proxySession');
      
      // Redirect to login (only for admin portal, not widget/consumer pages)
      const currentPath = window.location.pathname;
      if (!currentPath.includes('/widget') && !currentPath.includes('/consumer')) {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;